
import { EVENTS } from '@/scripts/constants/css-classes'
export default {
  name: 'rb-base-editorial-sticky-bar',
  data() {
    return {
      scrollPosition: 0,
      isSticky: false,
      offsetShimPosition: 0,
    }
  },
  mounted() {
    if (this.canBeSticky) {
      window.addEventListener(EVENTS.SCROLL, this.onScroll)
    }
  },
  beforeDestroy() {
    window.removeEventListener(EVENTS.SCROLL, this.onScroll)
  },
  methods: {
    onScroll() {
      const currentScroll = window.scrollY
      const shimPosition =
        this.$refs.wrapperBarShim.getBoundingClientRect().top +
        currentScroll -
        this.offsetShimPosition
      if (currentScroll > shimPosition) {
        this.isSticky = true
      } else {
        this.isSticky = false
      }
      this.scrollPosition = window.scrollY || document.documentElement.scrollTop
      this.onScrollCallback()
    },
    onScrollCallback() {
      this.offsetShimPosition = 0
    },
  },
}
